module.exports = __webpack_public_path__ + "static/ob_tobori_top-7d9bece11abe977147ed4046b0d03079.jpg";